"use client";
import usePreferencesHook from "@/hooks/usePreferences";
import React, { Suspense } from "react";


const DynamicLayout: React.FC<{
  children: React.ReactNode;
  lng: string;
}> = ({ children, lng }) => {
  const { theme } = usePreferencesHook();
  switch (theme) {
    case "vendor_market":
      return <Suspense>{children}</Suspense>;
    case "vendor_fashion":
      return <Suspense>{children}</Suspense>;
    case "vendor_food":
      return <Suspense>{children}</Suspense>;
    default:
      // Default layout if no theme matches
      return <Suspense>{children}</Suspense>;
  }
};

export default DynamicLayout;
